module.exports = __webpack_public_path__ + "static/media/LOGO-kmk-500x500px.7df745a7.png";